<div class="signature-pad-container">
    <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
    <div class="signature-pad-controls d-flex justify-content-center mt-2">
        <button class="btn btn-secondary me-2 me-md-4" (click)="clearSignature()" [disabled]="!isTouched">Clear Signature</button>
        <button class="btn btn-primary" (click)="acceptSignature()" [disabled]="!signatureDataURL">Accept Signature</button>
    </div>
</div>
